import { render, staticRenderFns } from "./AddTax.vue?vue&type=template&id=4b63e5f9&scoped=true&"
import script from "./AddTax.vue?vue&type=script&lang=js&"
export * from "./AddTax.vue?vue&type=script&lang=js&"
import style0 from "./AddTax.vue?vue&type=style&index=0&id=4b63e5f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b63e5f9",
  null
  
)

export default component.exports